import React from 'react';

export const LazyMdmDeviceListPage = React.lazy(() => import('./MdmDeviceListPage'));
export const LazyMdmDepDevicePage = React.lazy(() => import('./MdmDepDevicePage'));
export const LazyMdmDepProfilePage = React.lazy(() => import('./MdmDepProfilePage'));
